import {Link} from 'react-router-dom';
export default function ListCard() {
    return (
    <>
     <div class="TL-Card">
                <img src={require("../../TutorImage.jpg")} alt="Tutor" class="TL-CardImage"/>
                <div>
                    <h1>Tutor name</h1>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec lobortis purus nec libero ultricies, et ultricies arcu euismod. Donec scelerisque consectetur dapibus. Mauris posuere dolor ac metus dapibus, tincidunt fermentum massa dictum. </p>
                    <Link to="/tutor-profile-page" class="Button-Small" style={{textDecoration: 'none'}}>Tutor Profile</Link>
                </div>
    </div>
    <div class="TL-Card-T">
            <div>
                <img src={require("../../TutorImage.jpg")} alt="Tutor" class="TL-CardImage"/>
                <div>
                    <h1>Tutor name</h1>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec lobortis purus nec libero ultricies, et ultricies arcu euismod. Donec scelerisque consectetur dapibus. Mauris posuere dolor ac metus dapibus, tincidunt fermentum massa dictum. </p>
                    <Link to="/tutor-profile-page" class="Button-Small" style={{textDecoration: 'none'}}>Tutor Profile</Link>
                </div>
            </div>
    </div>
    </>
    )
}